import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import Layout from "../components/Layout";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function BekreftEpost() {
  const { token } = useParams();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [err, setErr] = useState("");

  useEffect(() => {
    let cancelled = false;
    api.get(`/auth/verify-email/${token}`).then(async () => {
      if (cancelled) return;
      setState("ok");
      // Refresh auth-state hvis allerede logget inn
      try { await refresh(); } catch { /* ignorerer */ }
      setTimeout(() => nav("/", { replace: true }), 2500);
    }).catch((e) => {
      if (cancelled) return;
      setErr(e.response?.data?.detail || "Kunne ikke bekrefte");
      setState("error");
    });
    return () => { cancelled = true; };
  }, [token, nav, refresh]);

  return (
    <Layout>
      <div className="max-w-md mx-auto pt-20 text-center" data-testid="verify-email-page">
        {state === "loading" && (
          <>
            <Loader2 className="h-10 w-10 text-[var(--magenta)] animate-spin mx-auto mb-6" />
            <p className="font-meta text-[10px] tracking-[0.3em] text-[var(--cream-soft)]">BEKREFTER…</p>
          </>
        )}
        {state === "ok" && (
          <>
            <CheckCircle2 className="h-12 w-12 text-emerald-400 mx-auto mb-6" />
            <h1 className="font-fraunces italic text-3xl text-[var(--cream)] mb-3">E-posten er bekreftet</h1>
            <p className="text-sm text-[var(--cream-soft)]">Tar deg videre om et øyeblikk…</p>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="h-12 w-12 text-[var(--magenta)] mx-auto mb-6" />
            <h1 className="font-fraunces italic text-3xl text-[var(--cream)] mb-3">Lenken er ugyldig</h1>
            <p className="text-sm text-[var(--cream-soft)] mb-6">{err}</p>
            <Link to="/?tab=login" className="font-meta text-xs tracking-[0.15em] text-[var(--magenta)] hover:underline">
              Tilbake til innlogging
            </Link>
          </>
        )}
      </div>
    </Layout>
  );
}
